/** Larger per-frame moves are arrivals or teleports, not walking. */
export const PORTAL_MAX_STEP = 1;
const dot = (a, b) => a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
const sub = (a, b) => [a[0] - b[0], a[1] - b[1], a[2] - b[2]];
/** Whether moving from `from` to `to` passes through the opening from its front side to its back. */
export function crossesPortal(portal, from, to) {
    const step = sub(to, from);
    if (Math.hypot(...step) > PORTAL_MAX_STEP)
        return false;
    const before = dot(sub(from, portal.center), portal.facing);
    const after = dot(sub(to, portal.center), portal.facing);
    if (!(before > 0 && after <= 0))
        return false;
    const t = before / (before - after);
    const offset = sub([from[0] + step[0] * t, from[1] + step[1] * t, from[2] + step[2] * t], portal.center);
    // Facing is horizontal, so the opening's right axis is facing × up and its up axis is world Y.
    const right = [-portal.facing[2], 0, portal.facing[0]];
    return Math.abs(dot(offset, right)) <= portal.width / 2 && Math.abs(offset[1]) <= portal.height / 2;
}
/** The first portal crossed by the move, if any. */
export function findCrossedPortal(portals, from, to) {
    return portals.find((portal) => crossesPortal(portal, from, to));
}
/** Places a portal `distance` behind a viewer at `eye` looking along `forward`, facing them, opening centred `drop` below the eye. */
export function placeBehindViewer(eye, forward, distance, drop) {
    const length = Math.hypot(forward[0], forward[2]);
    const facing = length > 1e-6 ? [forward[0] / length, 0, forward[2] / length] : [0, 0, -1];
    return {
        center: [eye[0] - facing[0] * distance, eye[1] - drop, eye[2] - facing[2] * distance],
        facing,
    };
}
